<template>
  <div class="content-container">
    <div v-loading="specServiceGridLoading" class="grid-scroll">
      <GridVx
        ref="specServiceGrid"
        :columns="columns"
        :rows="rows"
        :auto-size-cell="true"
        class="agGrid"
        dom-layout="scroll"
        @selectionChanged="onSelectRows"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->
    <el-col class="bottom-btns-container">
      <div class="button-containers mb-0">
        <button
          :disabled="!enableDelete"
          class="btn primary small outline"
          @click="deleteSpecService"
        >
          {{ $t('button.deleteService') }}
        </button>
        <button
          :disabled="!enableEdit"
          class="btn primary small"
          @click="fnShowEditDialog"
        >
          {{ $t('button.modifyService') }}
        </button>
        <button class="btn primary small" @click="fnShowAddDialog">
          {{ $t('button.addService') }}
        </button>
      </div>
      <!-- <el-button type="primary" @click="fnShowAddDialog">
        Thêm dịch vụ
      </el-button>
      <el-button type="danger" @click="deleteSpecService"> Xóa dịch vụ </el-button> -->
    </el-col>

    <!-- DIALOG -->
    <el-dialog
      :title="
        isEditDialog
          ? $t('dialog.titleServiceModify')
          : $t('dialog.titleServiceAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      class="body-overflow__visible"
      width="800px"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row" style="gap: 20px">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.code') }}
                  </div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    :name="$t('field.code')"
                  >
                    <input
                      v-model="formSpecService.special_service.code"
                      :disabled="isEditDialog"
                      type="text"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.transactionPage') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.transactionPage')"
                  >
                    <!-- <select
                      v-model="
                        formSpecService.special_service.transaction_domain_id
                      "
                    >
                      <option
                        v-for="option in transPageOptions"
                        :key="option.id"
                        :label="option.desc"
                        :value="option.id"
                      />
                    </select> -->
                    <el-select
                      v-model="
                        formSpecService.special_service.transaction_domain_id
                      "
                      placeholder=""
                    >
                      <el-option
                        v-for="option in transPageOptions"
                        :key="option.id"
                        :label="option.desc"
                        :value="option.id"
                      />
                    </el-select>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.currency') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.currency')"
                  >
                    <!-- <select
                      v-model="formSpecService.special_service.currency_id"
                    >
                      <option
                        v-for="option in currencyOptions"
                        :key="option.id"
                        :label="option.code"
                        :value="option.id"
                      />
                    </select> -->
                    <el-select
                      v-model="formSpecService.special_service.currency_id"
                      placeholder=""
                    >
                      <el-option
                        v-for="option in currencyOptions"
                        :key="option.id"
                        :label="option.code"
                        :value="option.id"
                      />
                    </el-select>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row" style="gap: 20px">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider
                    rules="number|min_value:0|max:20"
                    :name="$t('field.feeAmount')"
                  >
                    <div class="label">
                      {{ $t('field.feeAmount') }}
                    </div>
                    <!-- <input
                      v-model="formSpecService.special_service.fee"
                      min="0"
                      type="number"
                    /> -->
                    <VxCurrencyInput
                      v-model="formSpecService.special_service.fee"
                    />
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-8">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.desc') }}
                  </div>
                  <validation-provider
                    rules="required|max:200"
                    :name="$t('field.desc')"
                  >
                    <textarea
                      v-model="formSpecService.special_service.desc"
                      rows="3"
                      style="width: 100%"
                    />
                  </validation-provider>
                </div>
              </div>

              <!-- <div class="das-form-col col-4">
                <div class="das-form-input">
                  <validation-provider
                    rules="number|min_value:0|max:20"
                    :name="$t('field.quantityInStock')"
                  >
                    <div class="label">{{ $t('field.quantityInStock') }}</div>
                    <input
                      v-model.number="
                        formSpecService.special_service.quantity_in_stock
                      "
                      min="0"
                      type="number"
                    />
                  </validation-provider>
                </div>
              </div> -->
            </div>
            <div class="das-form-row"></div>
            <!-- <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input flex align-center">
                  <div class="label" style="margin-right: 5px">
                    {{ $t('field.manageSaleQuantity') }}
                  </div>
                  <el-switch
                    v-model="
                      formSpecService.special_service.manage_sale_quantity
                    "
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div> -->
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="separate_room_fee"
                      v-model="
                        formSpecService.special_service.separate_room_fee
                      "
                      type="checkbox"
                    />
                    <label for="separate_room_fee">
                      {{ $t('field.separateFromRoomRate') }}
                    </label>
                  </div>
                  <div class="checkbox-wrap ml-10">
                    <input
                      id="open_price"
                      v-model="formSpecService.special_service.open_price"
                      type="checkbox"
                    />
                    <label for="open_price">
                      {{ $t('field.openPrice') }}
                    </label>
                  </div>
                  <div class="checkbox-wrap ml-10">
                    <input
                      id="monthly_price"
                      v-model="formSpecService.special_service.monthly_price"
                      type="checkbox"
                    />
                    <label for="monthly_price">
                      {{ $t('field.monthlyFee') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->
      <div class="das-form-container">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <div class="main-title">
              <div class="label required">
                {{ $t('dialog.titleRevenueRecognizeTransaction') }}
              </div>
            </div>
          </div>
          <div>
            <button class="btn primary small" @click="addTransRow">
              {{ $t('button.add') }}
            </button>
          </div>
        </div>

        <div
          v-loading="transGridLoading"
          class="grid-scroll"
          style="height: 200px"
        >
          <GridVx
            ref="transGrid"
            :suppress-row-click-selection="true"
            :auto-select-first-row="false"
            :auto-size-cell="true"
            :columns="transactionColumns"
            :rows="formSpecService.transactions"
            :context="context"
            class="agGrid"
            dom-layout="scroll"
            @selectionChanged="onSelectRows"
          />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updateSpecService"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addSpecService">
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="dialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEditDialog"
          type="primary"
          @click="updateSpecService"
        >Cập nhật</el-button>
        <el-button
          v-else
          type="primary"
          @click="addSpecService"
        >Tạo mới</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import {
  getSpecialServiceListApi,
  addSpecialServiceApi,
  deleteSpecialServiceApi,
  getSpecialServiceTransApi,
  updateSpecialServiceApi,
  getSpecialServiceDetailApi
} from '@/api/Service_Policy/specialService'
import { getTransPageListApi } from '@/api/common/code'
import { getAllCurrencyApi } from '@/api/common/currency'
import { Message } from 'element-ui'
import {
  CellRenderTextInput,
  CellRenderSelectWithSearchTable,
  CellRenderDeleteIcon,
  CellRenderCheckboxReadonly,
  CellRenderNumberInput
} from '@/utils/cellRenders'
import CurrencyInput from '@/components/ui/currencyInput.vue'
import { h } from 'vue'

const DEFAULT_FORM_SPEC_SERVICE = {
  special_service: {
    id: null,
    code: null,
    desc: null,
    transaction_domain_id: null,
    fee: 0,
    currency_id: null,
    separate_room_fee: null,
    open_price: null,
    monthly_price: null,
    manage_sale_quantity: null,
    quantity_in_stock: 0
  },
  transactions: []
}

export default {
  components: {
    CellRenderTextInput,
    CellRenderSelectWithSearchTable,
    CellRenderDeleteIcon,
    CurrencyInput,
    CellRenderCheckboxReadonly,
    CellRenderNumberInput
  },
  data() {
    return {
      specServiceGridLoading: false,
      transGridLoading: false,
      form: [],
      // totalPage: 0,
      // currentPage: 0,
      isEditDialog: false,

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      dialogFormVisible: false,
      searchParams: {
        // page_size: 10,
        // page_num: 1,
        // orderTp: 'ASC'
      },
      formSpecService: {
        special_service: {
          id: null,
          code: null,
          desc: null,
          transaction_domain_id: null,
          fee: 0,
          currency_id: null,
          separate_room_fee: null,
          open_price: null,
          monthly_price: null,
          manage_sale_quantity: null,
          quantity_in_stock: 0
        },
        transactions: []
      },
      context: null,
      columns: [
        // {
        //   headerName: "",
        //   field: "index",
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false,
        // },
        {
          headerName: this.$t('grid.column.specialServiceCode'),
          field: 'code',
          tooltipField: 'code',
          sortable: false,
          // cellClass: "grid-cell-centered",
          minWidth: 180
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          sortable: false,
          tooltipField: 'desc',
          // cellClass: "grid-cell-centered",
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.openPrice'),
          field: 'open_price',
          sortable: false,
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          // cellClass: "grid-cell-centered",
          minWidth: 70,
          maxWidth: 70
        },
        {
          headerName: this.$t('grid.column.feeAmount'),
          field: 'fee',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          sortable: false,
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          }
        },
        {
          headerName: this.$t('grid.column.currencyCode'),
          field: 'currency_code',
          tooltipField: 'currency_code',
          sortable: false,
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.includingInRoomRate'),
          // field: "separate_room_fee",
          sortable: false,
          valueGetter: params => !params.data.separate_room_fee,
          cellRenderer: 'CellRenderCheckboxReadonly',
          minWidth: 200,
          maxWidth: 200,
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center'
        }
        // {
        //   headerName: "Mô tả",
        //   field: "name",
        //   // cellRenderer: 'CellRenderTextInput',
        //   cellClass: "grid-cell-centered",
        // },
      ],
      rows: [],

      transactionColumns: [
        {
          headerName: this.$t('grid.column.transaction'),
          field: 'transaction_code',
          sortable: false,
          // cellClass: "grid-cell-centered",
          cellRenderer: params => {
            if (params.data.transaction_code && params.data.transaction_desc) {
              return `${params.data.transaction_code} - ${params.data.transaction_desc}`
            }
            return ''
          },
          tooltipValueGetter: params => {
            if (params.data.transaction_code && params.data.transaction_desc) {
              return `${params.data.transaction_code} - ${params.data.transaction_desc}`
            }
            return ''
          },
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.subTransaction'),
          field: 'sub_transaction_code',
          sortable: false,
          // cellClass: "grid-cell-centered",
          cellRenderer: 'CellRenderSelectWithSearchTable',
          cellRendererParams: params => ({
            indexField: 'sub_transaction_id',
            searchFields: ['transaction_id_desc', 'sub_transaction_id_desc'],
            rows: this.transOptions,
            columns: [
              {
                headerName: this.$t('grid.column.transaction'),
                field: 'transaction_code',
                tooltipValueGetter: params =>
                  `${params.data.transaction_code} - ${params.data.transaction_desc}`,
                cellRenderer: params =>
                  `${params.data.transaction_code} - ${params.data.transaction_desc}`,
                // cellClass: "grid-cell-centered",
                flex: 1
              },
              {
                headerName: this.$t('grid.column.subTransaction'),
                tooltipValueGetter: params =>
                  `${params.data.sub_transaction_code} - ${params.data.sub_transaction_desc}`,
                cellRenderer: params =>
                  `${params.data.sub_transaction_code} - ${params.data.sub_transaction_desc}`,
                field: 'sub_transaction_code',
                // cellClass: "grid-cell-centered",
                flex: 1
              }
            ],
            selectedIndexFieldValue: params.data.sub_transaction_id,
            scopedSlotsValue: ({ selectedValue: selectedData }) => {
              return h('span', [
                selectedData?.sub_transaction_code,
                ' - ',
                selectedData?.sub_transaction_desc
              ])
            },
            // inputRendererParams: {
            //   tag: 'span',
            //   textArray: [
            //     selectedData?.sub_transaction_code,
            //     ' - ',
            //     selectedData?.sub_transaction_desc
            //   ]
            // },
            dropdownWidth: 400,
            colName: 'sub_transaction_desc'
          }),
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.recordPercentage'),
          field: 'record_percentage',
          cellRenderer: 'CellRenderNumberInput',
          cellRendererParams: () => {
            return {
              type: 'number',
              colName: 'record_percentage'
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 140,
          maxWidth: 140,
          sortable: false
        },
        {
          headerName: '',
          field: 'code',
          cellRenderer: 'CellRenderDeleteIcon',
          // cellClass: "grid-cell-centered",
          maxWidth: 70,
          sortable: false
        }
      ],

      currencyOptions: [],
      transPageOptions: [],
      transOptions: [],
      transRowList: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetFormSpecService()
    }
  },

  mounted() {
    this.attachData()

    // Get Select options
    this.fnGetCurrencyOptions()
    this.fnGetTransPageOptions()
    this.fnGetSpecServiceOptions()

    // GRID
    this.context = { componentParent: this }
    this.specServiceGridApi = this.$refs.specServiceGrid.gridApi
  },
  methods: {
    fnTest() {},
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    // async onPageChanged(pageNum) {
    //   this.searchParams.pageNum = pageNum;
    //   await this.attachData();
    // },
    // async onPageSizeChange(pageSize) {
    //   this.searchParams.page_size = pageSize;
    //   this.searchParams.page_num = 1;
    //   await this.attachData();
    // },
    async attachData() {
      this.specServiceGridLoading = true
      let data = await getSpecialServiceListApi(this.searchParams)
      this.specServiceGridLoading = false
      this.rows = data.data
      // this.totalPage = Math.ceil(data.total / this.searchParams.page_size);
      // this.currentPage = data.data.length == 0 ? 0 : data.page_num;
    },
    fnValidateFormTransList() {
      let totalPercent = 0

      if (!this.formSpecService.transactions?.length) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.enterTransactionInformation')
        })
        return false
      }

      for (let i = 0; i < this.formSpecService.transactions.length; i++) {
        const transactionItem = this.formSpecService.transactions[i]
        if (
          !transactionItem.transaction_id ||
          !transactionItem.sub_transaction_id ||
          transactionItem.record_percentage === null ||
          transactionItem.record_percentage === undefined
        ) {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.enterTransactionInformation')
          })
          return false
        } else if (
          transactionItem.record_percentage < 0 ||
          transactionItem.record_percentage > 100
        ) {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.recordPercentageMustInRangeOf0And100')
          })
          return false
        }
        totalPercent += Number(transactionItem.record_percentage)
      }

      let subTransactionIds = new Set(
        this.formSpecService.transactions.map(item => item.sub_transaction_id)
      )
      if (subTransactionIds.size != this.formSpecService.transactions.length) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.subTransactionMustNotOverlapping')
        })
        return false
      }

      if (totalPercent !== 100) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.totalPercentageMustEqual100')
        })
        return false
      }

      return true
    },
    getSanitizedSpecServiceForm() {
      let transactions = this.formSpecService.transactions.filter(
        item => item.sub_transaction_id && item.transaction_id
      )
      return {
        transactions,
        special_service: this.formSpecService.special_service
      }
    },
    async addSpecService() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      if (!this.fnValidateFormTransList()) {
        return
      }
      const form = this.getSanitizedSpecServiceForm()
      addSpecialServiceApi(form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateSpecService() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      if (!this.fnValidateFormTransList()) {
        return
      }
      const form = this.getSanitizedSpecServiceForm()
      updateSpecialServiceApi(form)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async deleteSpecService() {
      const rowsSelected = this.specServiceGridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectService')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteService'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deleteSpecialServiceApi([...id_list])
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    async getSpecServiceDetail(serviceId) {
      const resData = await getSpecialServiceDetailApi(serviceId)
      return resData.data
    },

    async onDoubleClicked(rows) {
      this.isEditDialog = true
      const rowData = rows[0]
      const serviceDetail = await this.getSpecServiceDetail(rowData.id)
      this.formSpecService = {
        special_service: serviceDetail.special_service,
        transactions: serviceDetail.transaction
      }
      this.dialogFormVisible = true
    },

    onSelectRows(rows) {
      this.enableDelete = !!rows.length
      this.enableEdit = rows?.length == 1
    },

    resetFormSpecService() {
      this.formSpecService = {
        special_service: {
          id: null,
          code: null,
          desc: null,
          transaction_domain_id: null,
          fee: 0,
          currency_id: null,
          separate_room_fee: null,
          open_price: null,
          monthly_price: null,
          manage_sale_quantity: null,
          quantity_in_stock: 0
        },
        transactions: []
      }
    },

    fnShowAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
    },
    async fnShowEditDialog() {
      this.isEditDialog = true
      const rowData = this.specServiceGridApi.getSelectedRows()[0]
      this.dialogFormVisible = true
      const serviceDetail = await this.getSpecServiceDetail(rowData.id)
      this.formSpecService = {
        special_service: serviceDetail.special_service,
        transactions: serviceDetail.transaction
      }
    },

    addTransRow() {
      this.formSpecService.transactions.push({
        transaction_id: null,
        transaction_desc: null,
        sub_transaction_id: null,
        sub_transaction_desc: null,
        record_percentage: null
      })
    },

    // GET SELECT OPTIONS
    async fnGetCurrencyOptions() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data.data
    },

    async fnGetTransPageOptions() {
      const data = await getTransPageListApi()
      this.transPageOptions = data.data
    },

    async fnGetSpecServiceOptions() {
      const data = await getSpecialServiceTransApi({ transaction_group: 1 })
      this.transOptions = data.data.map(item => ({
        ...item,
        transaction_id_desc: `${item.transaction_id} - ${item.transaction_desc}`,
        sub_transaction_id_desc: `${item.sub_transaction_id} - ${item.sub_transaction_desc}`
      }))
    },
    // GET SELECT OPTIONS

    onChangeSpecSerTrans(data) {
      this.formSpecService.transactions = [...data]
    },

    // AGGRID INPUTS' ACTION
    textInputChange(params, value, colName) {
      this.formSpecService.transactions[params.rowIndex][colName] = value
    },
    selectSearchTableChange(params, valueData, colName) {
      const unitRowIndex = params.rowIndex

      this.formSpecService.transactions[unitRowIndex] = {
        ...this.formSpecService.transactions[unitRowIndex],
        sub_transaction_id: valueData.sub_transaction_id,
        sub_transaction_desc: valueData.sub_transaction_desc,
        sub_transaction_code: valueData.sub_transaction_code,
        transaction_id: valueData.transaction_id,
        transaction_desc: valueData.transaction_desc,
        transaction_code: valueData.transaction_code
      }

      this.$refs.transGrid.gridApi.setRowData(this.formSpecService.transactions)

      // For re-rendering
      // this.$refs.transGrid.gridApi.forEachNode((node) => {
      //   if (unitRowIndex == node.rowIndex) {
      //     try {
      //       node.setDataValue("transaction_id", valueData.transaction_id);
      //       node.setDataValue("transaction_desc", valueData.transaction_desc);
      //       node.setDataValue(
      //         "sub_transaction_id",
      //         valueData.sub_transaction_id
      //       );
      //       node.setDataValue(
      //         "sub_transaction_desc",
      //         valueData.sub_transaction_desc
      //       );
      //     } catch (err) {
      //     }
      //   }
      // });
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.formSpecService.transactions.splice(idx, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// .el-form-item {
//   margin-bottom: 22px;

// }

#table {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #ddd;
  overflow-x: scroll;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:first-child {
    th,
    td {
      border-left: none;
    }
  }

  tr:last-child {
    th,
    td {
      border-right: none;
    }
  }

  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #0973d6;
    color: white;
  }

  tbody {
    tr,
    td {
      height: 40px;
    }
  }
}
</style>
